import React, { createContext, useContext, PropsWithChildren } from 'react';
import { ScheduleGroupDefinition } from '../types';

interface ScheduleGroupContextValue {
  groups: ScheduleGroupDefinition[];
  addGroup: (name: string) => void;
  updateGroup: (name: string, updates: Partial<ScheduleGroupDefinition>) => void;
}

const ScheduleGroupContext = createContext<ScheduleGroupContextValue>({
  groups: [],
  addGroup: () => {},
  updateGroup: () => {},
});

interface ScheduleGroupProviderProps {
  groups: ScheduleGroupDefinition[];
  onAddGroup: (name: string) => void;
  onUpdateGroup: (name: string, updates: Partial<ScheduleGroupDefinition>) => void;
}

export const ScheduleGroupProvider: React.FC<PropsWithChildren<ScheduleGroupProviderProps>> = ({
  children,
  groups,
  onAddGroup,
  onUpdateGroup,
}) => (
  <ScheduleGroupContext.Provider value={{ groups, addGroup: onAddGroup, updateGroup: onUpdateGroup }}>
    {children}
  </ScheduleGroupContext.Provider>
);

export const useScheduleGroups = () => useContext(ScheduleGroupContext);
